import React, { useState } from 'react';
import { Calculator, TrendingUp, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import API_BASE_URL from '../config/api';

const MiniSimulator3emePilier = () => {
  const [montant, setMontant] = useState(7258);
  const [duree, setDuree] = useState(20);
  const [taux, setTaux] = useState(15);
  const [result, setResult] = useState(null);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const calculateEconomie = () => {
    // Calcul simple de l'économie fiscale
    const economieAnnuelle = montant * (taux / 100);
    const economieTotal = economieAnnuelle * duree;
    const capitalFinal = montant * duree; // Simplifié
    
    setResult({
      economieAnnuelle,
      economieTotal,
      capitalFinal
    });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('fr-CH', {
      style: 'currency',
      currency: 'CHF',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const handleSendPDF = async () => {
    if (!email || !result) return;
    
    setLoading(true);
    
    // Sauvegarder la position actuelle du scroll
    const scrollPosition = window.scrollY;
    
    try {
      const response = await fetch(`${API_BASE_URL}/lead-magnet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          guide: 'Guide 3ème Pilier',
          position: 'simulator',
          simulator_data: {
            montant: montant,
            duree: duree,
            tauxImposition: taux,
            economieAnnuelle: result.economieAnnuelle,
            economieTotal: result.economieTotal,
            capitalFinal: result.capitalFinal
          }
        })
      });
      
      if (response.ok) {
        setSuccess(true);
        
        // Restaurer la position du scroll
        setTimeout(() => {
          window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }, 0);
        
        setTimeout(() => setSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Error sending PDF:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass p-8 rounded-2xl border border-white/20 shadow-xl mb-8 bg-gradient-to-br from-blue-500/10 to-purple-500/10" id="simulateur">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-3 rounded-xl">
          <Calculator className="w-8 h-8 text-white" />
        </div>
        <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          📊 Calcule gratuitement ton économie fiscale 2025
        </h3>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Montant annuel versé (CHF)
          </label>
          <input
            type="range"
            min="1000"
            max="7258"
            step="100"
            value={montant}
            onChange={(e) => setMontant(Number(e.target.value))}
            className="w-full h-2 bg-white/20 rounded-lg appearance-none cursor-pointer"
          />
          <div className="text-right text-2xl font-bold text-white mt-2">
            {formatCurrency(montant)}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Durée (années)
          </label>
          <input
            type="range"
            min="5"
            max="40"
            step="1"
            value={duree}
            onChange={(e) => setDuree(Number(e.target.value))}
            className="w-full h-2 bg-white/20 rounded-lg appearance-none cursor-pointer"
          />
          <div className="text-right text-2xl font-bold text-white mt-2">
            {duree} ans
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Taux d'imposition estimé (%)
          </label>
          <input
            type="range"
            min="8"
            max="45"
            step="1"
            value={taux}
            onChange={(e) => setTaux(Number(e.target.value))}
            className="w-full h-2 bg-white/20 rounded-lg appearance-none cursor-pointer"
          />
          <div className="text-right text-2xl font-bold text-white mt-2">
            {taux}%
          </div>
        </div>

        <button
          onClick={calculateEconomie}
          className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-4 rounded-xl font-semibold hover:from-blue-600 hover:to-purple-700 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
        >
          <Calculator className="w-5 h-5" />
          Calculer mon économie
        </button>

        {result && (
          <div className="mt-6 p-6 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-xl border border-green-500/30">
            <div className="flex items-center gap-2 mb-4">
              <TrendingUp className="w-6 h-6 text-green-400" />
              <h4 className="text-xl font-bold text-white">Votre économie potentielle</h4>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Économie fiscale annuelle :</span>
                <span className="text-2xl font-bold text-green-400">{formatCurrency(result.economieAnnuelle)}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Économie totale sur {duree} ans :</span>
                <span className="text-2xl font-bold text-green-400">{formatCurrency(result.economieTotal)}</span>
              </div>
              <div className="flex justify-between items-center pt-3 border-t border-white/10">
                <span className="text-gray-300">Capital accumulé :</span>
                <span className="text-3xl font-bold text-white">{formatCurrency(result.capitalFinal)}</span>
              </div>
            </div>
            <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/30 rounded-xl">
              <p className="text-sm text-gray-300 mb-3">
                📧 Recevez votre rapport personnalisé par email
              </p>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  placeholder="Votre email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-500"
                />
                <button
                  onClick={handleSendPDF}
                  disabled={!email || loading}
                  className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {loading ? 'Envoi...' : 'Recevoir'}
                </button>
              </div>
              {success && (
                <p className="text-green-400 text-sm mt-2">✅ Rapport envoyé avec succès ! Consultez votre boîte mail.</p>
              )}
            </div>
            
            <Link
              to="/contact"
              className="mt-4 w-full bg-white text-blue-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-all flex items-center justify-center gap-2"
            >
              Optimiser mon 3ème pilier
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MiniSimulator3emePilier;